import { useState } from "react";
import SectionTitle from "../shared/sectionTitle/sectionTitle";
import { Radio } from "antd";
import type { RadioChangeEvent } from "antd";
import Profile from "./profile/profile";
import LoginInformation from "./loginInformation/loginInformation";
import { useParams } from "react-router-dom";
import CredentialsTable from "./credentials/credentials";

type TabPosition = "login" | "profile" | "credentials";

const Settings = () => {
  const { id } = useParams();
  const [mode, setMode] = useState<TabPosition>("profile");
  const handleModeChange = (e: RadioChangeEvent) => {
    setMode(e.target.value);
  };

  return (
    <>
      {window.location.href.includes("settings") && (
        <SectionTitle
          logo={true}
          sectionName={
            id === undefined ? "My Seabc Settings" : "Student Profile"
          }
        />
      )}
      <div className="max-w-6xl pt-4" style={{ margin: "0 auto" }}>
        {id === undefined && (
          <Radio.Group
            size="large"
            optionType="button"
            buttonStyle="solid"
            onChange={handleModeChange}
            value={mode}
            style={{ marginBottom: 8 }}
          >
            <Radio.Button value="login">Login Information</Radio.Button>
            <Radio.Button value="profile">My Profile</Radio.Button>
            <Radio.Button value="credentials">
              Education & Credentials
            </Radio.Button>
          </Radio.Group>
        )}
        <div>
          {mode === "login" && <LoginInformation />}
          {mode === "profile" && <Profile userId={id} />}
          {mode === "credentials" && <CredentialsTable />}
        </div>
      </div>
    </>
  );
};

export default Settings;
